define('views/wallet/pfdebit',[
    'views/_base/baseview',
    'text!views/wallet/pfdebit.html',
    'views/shared/button/button'
], function (BaseView, Template, ButtonComponent){
    'use strict';

    return BaseView.extend({
        id      : 'pfdebit-container',
        tagName : 'div',
        isRender: true,
        template: _.template(Template),
        events  : {
            'submit': 'requestDebitCardMODAL',
            'click .js-pfdebit-form-btn': 'requestDebitCardMODAL',
            'click #pf-modal-close-btn'  : 'closeMODAL'
        },
        initialize: function(options){
            options = options || {};

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            setTimeout(function(){
                that.addPfDebitButtonMODAL();
            },300);

            

            return this;
        },

        loadData: function(){},

        addPfDebitButtonMODAL: function(){

            this.pfdebit_button = new ButtonComponent({
                // General
                elementName        : '.js-pfdebit-form-button-container',
                calling_view       : this,
                // Transactional
                is_transaction     : false,
                // Default
                btn_label          : 'Send My Debit Card',
                btn_callback       : this.requestDebitCardMODAL,
                btn_retry_callback : this.requestDebitCardMODAL,
                // Confirm
                btn_confirm        : false,
                // Cancel
                btn_cancel         : true,
                btn_cancel_label   : 'Cancel',
                btn_cancel_callback: this.cancelRequestMODAL,
                // Success
                btn_success        : true,
                btn_success_delay  : 700,
                btn_success_label  : 'OK',
                btn_success_message: 'Your PayForward Debit Card request has been sent',
                btn_success_callback: this.requestSuccess,
                // Error
                btn_error          : true,
                btn_error_delay    : 700,
                btn_error_label    : 'Retry',
                btn_error_cancel_label: 'Cancel',
                btn_error_message  : 'There was an error trying to request a debit card. Please try again',
                btn_error_callback : this.canceledOnError
            });

        },

        cancelRequestMODAL: function(){
            var that = (that) ? that : this;

            that.closeMODAL();
        },

        requestSuccess: function(resetButtons, that){
            var that = (that) ? that : this;

            if(resetButtons.name){
                that.pfdebit_button[resetButtons.name]();
            } else {
                resetButtons(that.pfdebit_button);
            }

            $('.js-account-linked-accounts-pfdebit').hide();
            $('.js-order-pfdebit').hide();

            setTimeout(function(){
                that.closeMODAL();
            },500);
            
        },

        canceledOnError: function(that){},

        requestDebitCardMODAL: function(processComplete, that){
            var that = (that) ? that : this,
                cardholder_agreement = $('.js-pfdebit-terms'),
                agreed = cardholder_agreement.is(':checked');

            if(agreed){

                $.ajax({
                    url  : pf.accountsURL + '/ConvertToGPR',
                    type : 'POST',
                    async: true,
                    contentType: 'application/json; charset=utf-8',
                    traditional: true,
                    success: function(response){
                        
                        if(response){

                            pf.session.set({ CardType: enums.cardTypes.GPRDebitCard });

                            if(processComplete.name){
                                that.pfdebit_button[processComplete.name](true);
                            } else {
                                processComplete(true, that.pfdebit_button);
                            }
                            
                        } else {
                            that.pfdebit_button.updateErrorMessage('There was an error trying to request a debit card. Please try again');
                        
                            if(processComplete.name){
                                that.pfdebit_button[processComplete.name](false);
                            } else {
                                processComplete(false, that.pfdebit_button);
                            }
                        }

                    },
                    error: function (response,model) {
                        
                        that.pfdebit_button.updateErrorMessage('There was an error trying to request a debit card. Please try again');
                        
                        if(processComplete.name){
                            that.pfdebit_button[processComplete.name](false);
                        } else {
                            processComplete(false, that.pfdebit_button);
                        }

                    }
                });

            } else {

                that.pfdebit_button.updateErrorMessage('You must agree to the Cardholder Agreement terms before you can send the request');
                
                if(processComplete.name){
                    that.pfdebit_button[processComplete.name](false);
                } else {
                    processComplete(false, that.pfdebit_button);
                }

            }

            return false;
            
        },

        closeMODAL: function(){
            $('#pf-modal-modern').fadeOut(function(){
                $('#pf-modal-modern').remove();
            });
        },

        close: function(){}
    });
});

